import React, { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import BackButton from "../BackButton";
import { validateEmptyFields } from "../../helpers/util";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import InputImageFieldGrid from "../common/InputImageFieldGrid";
import CustomButton from "components/CustomButton";
import { useNavigate } from "react-router-dom";

const SegmentProductForm = ({ title, goBack, defaultValues, submit, validate }) => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(true);
  const { control, handleSubmit } = useForm({ defaultValues });
  const watch = useWatch({ control });

  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Pago de Servicios</div>
          <div className="subtitle">Segmentos</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          direction="row"
          my={"40px"}
          maxWidth={"70%"}
          justifyContent="center"
          spacing={3}
        >
          <InputTextFieldGrid
            xs={6}
            name={"name"}
            control={control}
            required={"Debes agregar el nombre del segmento"}
            label={"Nombre"}
          />
          <InputImageFieldGrid
            xs={8}
            name={"logo"}
            control={control}
            required={"Debes agregar el logo del segmento"}
            label={"Logo"}
            style={{ display: "flex" }}
          />
          <Grid
            container
            item
            justifyContent="center"
            mt={4}
          >
            <CustomButton
              click={handleSubmit(submit)}
              name={"Guardar"}
              disabled={disabled}
            />
          </Grid>
        </Grid>

      </Grid>
    </>
  );
};

export default SegmentProductForm;
